import { useState, useEffect } from 'react'
import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { Helmet } from 'react-helmet-async'

export default function BlogPostAffordableFenceIdeas() {
  const [activeTab, setActiveTab] = useState<'all' | 'wood' | 'privacy' | 'vinyl'>('all')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const allFences = [
    { src: "/assets/images/Fence/Ameristar-Montage-Ornamental-fence-with-Final-top.jpg", alt: "Black Ameristar Montage ornamental steel fence with finial top design", caption: "Classic ornamental steel with decorative finials." },
    { src: "/assets/images/Fence/Ameristar-Montage-Plus-Ornamental-fence-with-Finial-top.jpg", alt: "Heavy-duty Ameristar Montage Plus ornamental metal fence panel", caption: "Durable steel fencing for boundary definition." },
    { src: "/assets/images/Fence/Ameristar-Montage-Plus-Ornamental-fence-with-Finials.jpg", alt: "Affordable Ameristar Montage Plus iron-style fencing with finials", caption: "Elegant iron-style look without the premium cost." },
    { src: "/assets/images/Fence/Cedar-Aspen-Estates-Style-fence-4x6-PT-wood-posts.jpg", alt: "Cedar Aspen Estates style wood fence built with 4x6 pressure-treated posts", caption: "Sturdy Aspen Estates style with pressure-treated supports." },
    { src: "/assets/images/Fence/Cedar-Aspen-Estates-style-fence-6x6-posts..jpg", alt: "Heavy-duty Cedar Aspen Estates fence utilizing thick 6x6 wooden posts", caption: "Upgraded 6x6 posts for high-wind resistance." },
    { src: "/assets/images/Fence/Cedar-Custom-fence-1x4-Hortizontal-pickets.jpg", alt: "Modern custom cedar fence featuring 1x4 horizontal wood pickets", caption: "Sleek 1x4 horizontal cedar boards." },
    { src: "/assets/images/Fence/Cedar-Custom-fence-1x6-pickets-with-1x2-Horizontal-Custom-Lattice-top.jpg", alt: "Custom cedar privacy fence with 1x6 pickets and 1x2 horizontal lattice top", caption: "Privacy base paired with a semi-open lattice top." },
    { src: "/assets/images/Fence/Cedar-Custom-fence-1x6-pickets-with-1x4-custom-Cedar-Lattice.jpg", alt: "Cedar property fence combining 1x6 vertical pickets and custom 1x4 cedar lattice", caption: "Heavy-duty custom lattice detailing." },
    { src: "/assets/images/Fence/Cedar-Custom-Horizontal-fence-1x6-_-1x2-pickets.jpg", alt: "Contemporary cedar horizontal fence mixing 1x6 and 1x2 wooden pickets", caption: "Alternating board sizes for modern texture." },
    { src: "/assets/images/Fence/Cedar-Fence-Fortress-III-Style-6x6-PT-wood-posts-stepped-.jpg", alt: "Stepped Fortress III style cedar fence on a slope with 6x6 pressure-treated posts", caption: "Stepped installation designed for sloped yards." },
    { src: "/assets/images/Fence/Cedar-fence-Fortress-III-Style-Cedar-6x6-posts-stepped.jpg", alt: "Premium Fortress III cedar fence stepped on uneven terrain with matching 6x6 posts", caption: "Full cedar construction tracking uneven ground." },
    { src: "/assets/images/Fence/Cedar-Fortress-II-Style-fence-4x6-PT-wood-posts.jpg", alt: "Affordable Fortress II style cedar fence using 4x6 pressure treated foundation posts", caption: "Cost-effective Fortress II style setup." },
    { src: "/assets/images/Fence/Cedar-Fortress-II-Style-fence.jpg", alt: "Classic Fortress II style cedar privacy fence installation", caption: "Standard Fortress II privacy design." },
    { src: "/assets/images/Fence/Cedar-gate-with-decorative-arboured-top.jpg", alt: "Custom cedar garden gate featuring a decorative wooden arbour top", caption: "Welcoming entryway with a custom arbour." },
    { src: "/assets/images/Fence/Cedar-Horizontal-1x6-fence-installed-on-front-of-posts.jpg", alt: "Continuous horizontal cedar fence with 1x6 boards face-mounted to posts", caption: "Face-mounted horizontal boards for a seamless look." },
    { src: "/assets/images/Fence/Cedar-Horizontal-gate-backside.jpg", alt: "Backside view of a heavy-duty cedar horizontal wooden gate", caption: "Reinforced gate framing for horizontal designs." },
    { src: "/assets/images/Fence/Cedar-Horiztonal-gate.jpg", alt: "Front view of a modern cedar horizontal slat yard gate", caption: "Clean horizontal lines extending through the gate." },
    { src: "/assets/images/Fence/Cedar-Magnum-board-fence-Fortress-2.jpg", alt: "Solid privacy cedar Magnum board fence in Fortress 2 style", caption: "Maximum privacy using thick Magnum boards." },
    { src: "/assets/images/Fence/Cedar-wood-gate-with-Cedar-2x6-supported-top.jpg", alt: "Sturdy cedar wood gate reinforced with a heavy 2x6 supported top frame", caption: "Sag-resistant gate with 2x6 top bracing." },
    { src: "/assets/images/Fence/Custom-Cedar-fence-with-1x4-Horizontal-pickets.jpg", alt: "Custom-built cedar property line fence with 1x4 horizontal slats", caption: "Minimalist 1x4 horizontal fencing." },
    { src: "/assets/images/Fence/Custom-Cedar-gate-with-Cedar-Pergola.jpg", alt: "Grand custom cedar gate integrated with a matching overhead cedar pergola", caption: "Statement gate with an integrated pergola structure." },
    { src: "/assets/images/Fence/Custom-Cedar-Horizontal-fence-1x6-_-1x2-pickets.jpg", alt: "Detailed view of a custom cedar horizontal fence alternating 1x6 and 1x2 boards", caption: "Intricate alternating horizontal pattern." },
    { src: "/assets/images/Fence/Custom-Magnum-Cedar-fence-with-Decorative-Arbour.jpg", alt: "High-privacy Magnum cedar fence featuring an integrated decorative arbour", caption: "Solid Magnum fencing meeting a decorative gateway." },
    { src: "/assets/images/Fence/Custom-Magnum-Cedar-Fence.jpg", alt: "Solid custom Magnum cedar fence built for total backyard privacy", caption: "Complete visual block with Magnum construction." },
    { src: "/assets/images/Fence/Espresso-wood-grain-gate-black-vinyl-picket-lattice.jpg", alt: "Espresso wood-grain vinyl gate featuring a black vertical picket lattice top", caption: "Wood-look vinyl with modern black accents." },
    { src: "/assets/images/Fence/Espresso-wood-grain-vinyl-fence-black-vertical-picket-lattice.jpg", alt: "Low maintenance Espresso wood-grain vinyl fence with black picket lattice", caption: "Dark espresso finish mimicking stained wood." },
    { src: "/assets/images/Fence/Espresso-wood-grain-vinyl-fence-with-black-Vertical-Picket-lattice.jpg", alt: "Affordable wood-alternative Espresso vinyl fence with black vertical lattice", caption: "Zero-maintenance vinyl with a contemporary top." },
    { src: "/assets/images/Fence/Pressure-Treated-wood-fence-with-Cedar-1x2-Horizontal-Lattice.jpg", alt: "Budget-friendly pressure-treated wood fence upgraded with a cedar 1x2 lattice top", caption: "Mixing PT wood with premium cedar accents." },
    { src: "/assets/images/Fence/Pressure-Treated-wood-Fortress-II-style-fence-4x6-posts.jpg", alt: "Cost-effective pressure-treated wood fence in Fortress II style with 4x6 posts", caption: "Highly affordable PT wood in a premium style." },
    { src: "/assets/images/Fence/Two-Tone-Privacy-Vinyl-Fence-Almond-_-White.jpg", alt: "Two-tone solid privacy vinyl fence contrasting Almond panels with White posts", caption: "Striking two-tone Almond and White design." },
    { src: "/assets/images/Fence/Two-toned-Custom-Vinyl-Gate-Khaki-_-White.jpg", alt: "Custom two-toned vinyl yard gate featuring Khaki infill and White framing", caption: "Khaki and White contrast for enhanced curb appeal." },
    { src: "/assets/images/Fence/Vinyl-fence-with-lattice-top-Almond-_-White.jpg", alt: "Almond and White two-tone vinyl fence finished with a decorative lattice top", caption: "Classic lattice top in a two-tone finish." },
    { src: "/assets/images/Fence/Vinyl-gate-Stone-_-White.jpg", alt: "Durable Stone and White colored vinyl garden gate", caption: "Stone-colored panels framed in crisp white." },
    { src: "/assets/images/Fence/Vinyl-Privacy-Fence-in-White.jpg", alt: "Classic solid white vinyl privacy fence for residential backyards", caption: "The quintessential bright white privacy fence." },
    { src: "/assets/images/Fence/White-Viny-Fence-with-Lattice-Top.jpg", alt: "Traditional white vinyl property fence with a square lattice top detail", caption: "Airy lattice top maintaining baseline privacy." },
    { src: "/assets/images/Fence/White-vinyl-1.jpg", alt: "Clean, affordable white vinyl residential fencing panel", caption: "Simple, highly affordable white vinyl." },
    { src: "/assets/images/2020/04/Decoartive-picket-top-Vinyl-Fence-Chestnut-Brown.jpg", alt: "Chestnut brown vinyl fence featuring a decorative scalloped picket top", caption: "Rich chestnut vinyl with an open picket top." }
  ]

  // Filtered categories
  const woodFences = allFences.filter(f => f.src.includes('Cedar') || f.src.includes('Pressure-Treated'))
  const privacyFences = allFences.filter(f => f.src.includes('Magnum') || f.src.includes('Fortress') || f.src.includes('Privacy') || f.src.includes('Aspen-Estates'))
  const vinylFences = allFences.filter(f => f.src.toLowerCase().includes('vinyl') || f.src.includes('Decoartive-picket'))

  const GalleryGrid = ({ images }: { images: typeof allFences }) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 my-8">
      {images.map((img, idx) => (
        <div key={idx} className="flex flex-col bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden group">
          <div className="relative h-64 overflow-hidden">
            <img 
              src={img.src} 
              alt={img.alt} 
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-4 bg-gray-50 flex-grow">
            <p className="text-gray-700 text-sm font-medium">{img.caption}</p>
          </div>
        </div>
      ))}
    </div>
  )

  // Consolidated Schema Data for Affordable Fence Ideas Blog
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BlogPosting",
        "headline": "Affordable Fence Ideas: 37 Budget-Friendly Designs",
        "description": "Discover 37 affordable fence ideas that balance durability, curb appeal, and budget constraints. Browse our gallery of wood, vinyl, and privacy designs.",
        "author": {
          "@type": "Organization",
          "name": "Busy Beaver Construction",
          "url": "https://busybeaverconstruction.com/"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Busy Beaver Construction",
          "logo": {
            "@type": "ImageObject",
            "url": "https://busybeaverconstruction.com/assets/images/2020/03/busy-beaver-logo.png"
          }
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://busybeaverconstruction.com/blog/affordable-fence-ideas"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://busybeaverconstruction.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://busybeaverconstruction.com/blog"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Affordable Fence Ideas",
            "item": "https://busybeaverconstruction.com/blog/affordable-fence-ideas"
          }
        ]
      }
    ]
  };

  return (
    <main className="bg-white">
      <Helmet>
        <title>Affordable Fence Ideas: 37 Budget-Friendly Designs | Busy Beaver Construction</title>
        <meta name="description" content="Discover 37 affordable fence ideas that balance durability, curb appeal, and budget constraints. Browse our gallery of wood, vinyl, and privacy designs." />
      </Helmet>

      {/* JSON-LD Schema placed OUTSIDE Helmet to ensure rendering */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />

      <Header />
      
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-7xl">
          
          <div className="max-w-4xl mx-auto mb-16 text-center">
            <h1 className="text-4xl md:text-5xl font-primary font-bold text-gray-900 mb-6 leading-tight">
              Affordable Fence Ideas: 37 Budget-Friendly Designs
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed">
              Securing your property doesn't have to drain your bank account. Whether you need to keep pets safe, block out noisy neighbors, or simply define your property lines, there are plenty of cost-effective fencing solutions available. This guide explores 37 affordable fence ideas that balance durability, curb appeal, and budget constraints. From classic pressure-treated wood and natural cedar designs to low-maintenance vinyl and ornamental metal, finding the right barrier depends on your specific privacy needs and local climate. Browse our gallery below to find the perfect budget-friendly inspiration for your next backyard renovation.
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-3 mb-12 border-b border-gray-200 pb-6">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 font-accent ${
                activeTab === 'all'
                  ? 'bg-beaver-green text-black shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              All Designs ({allFences.length})
            </button>
            <button
              onClick={() => setActiveTab('wood')}
              className={`px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 font-accent ${
                activeTab === 'wood'
                  ? 'bg-beaver-green text-black shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Wood Fence Ideas ({woodFences.length})
            </button>
            <button
              onClick={() => setActiveTab('privacy')}
              className={`px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 font-accent ${
                activeTab === 'privacy'
                  ? 'bg-beaver-green text-black shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Privacy Fence Ideas ({privacyFences.length})
            </button>
            <button
              onClick={() => setActiveTab('vinyl')}
              className={`px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 font-accent ${
                activeTab === 'vinyl'
                  ? 'bg-beaver-green text-black shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Vinyl Fence Ideas ({vinylFences.length})
            </button>
          </div>

          <article className="space-y-12">
            
            {activeTab === 'all' && (
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 font-secondary border-b pb-4">Affordable Fence Ideas</h2>
                <GalleryGrid images={allFences} />
              </section>
            )}

            {activeTab === 'wood' && (
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 font-secondary border-b pb-4">Affordable Wood Fence Ideas</h2>
                <p className="text-gray-700 text-lg mb-6">Wood offers the best balance of initial affordability and natural beauty. Pressure-treated options are the most budget-friendly, while cedar provides excellent natural rot resistance.</p>
                <GalleryGrid images={woodFences} />
              </section>
            )}

            {activeTab === 'privacy' && (
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 font-secondary border-b pb-4">Affordable Privacy Fence Ideas</h2>
                <p className="text-gray-700 text-lg mb-6">Block sightlines and reduce wind with these solid-panel designs, featuring board-on-board construction and gapless vinyl panels.</p>
                <GalleryGrid images={privacyFences} />
              </section>
            )}

            {activeTab === 'vinyl' && (
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 font-secondary border-b pb-4">Affordable Vinyl Fence Ideas</h2>
                <p className="text-gray-700 text-lg mb-6">While slightly higher in upfront material costs, vinyl fencing requires zero staining or sealing, making it incredibly affordable over a 10-year lifespan.</p>
                <GalleryGrid images={vinylFences} />
              </section>
            )}

          </article>
        </div>
      </section>
      
      <Footer />
    </main>
  )
}